
export const ImvFieldData = {
  nreg: {
    label: 'Numero De Registro: ',
    type: 'text'
  },
  cep: {
    label: 'CEP: ',
    type: 'text'
  },
  end: {
    label: 'Endereço: ',
    type: 'text'
  },
  bairro: {
    label: 'Bairro: ',
    type: 'text'
  },
  num: {
    label: 'Numero: ',
    type: 'text'
  },
  preco: {
    label: 'Valor: ',
    type: 'text'
  },
  quartos: {
    label: 'Quartos: ',
    type: 'text'
  },
  banheiros: {
    label: 'Banheiros: ',
    type: 'number'
  },
  garagem: {
    label: 'Vagas de Garagem: ',
    type: 'text'
  },
  acc_pets: {
    label: 'Aceita Pets: ',
    type: 'checkbox'
  },
  area: {
    label: 'Area Util: ',
    type: 'number'
  },
  cond: {
    label: 'Condiçao de Pagamento: ',
    type: 'text'
  },
  tipo: {
    label: 'Tipo do Imovel (aluguel, venda): ',
    type: 'text'
  },
  status: {
    label: 'Situação do Imovel: ',
    type: 'text'
  },
  descricao: {
    label: 'Descrição: ',
    type: 'text'
  },
};
